import { THEME_MODE } from '../../../constants/themeMode'

import DarkPreview from '../../../icons/unique/theme/dark.svg'
import LightPreview from '../../../icons/unique/theme/light.svg'
import SystemPreview from '../../../icons/unique/theme/system.svg'

export const QA_NAME_USER_THEME = 'userTheme'

export const USER_MENU_THEME_MODE_OPTIONS = [
  {
    Preview: LightPreview,
    qaName: 'userThemeLight',
    text: 'Header.ThemeLightKey',
    value: THEME_MODE.light,
  },
  {
    Preview: DarkPreview,
    qaName: 'userThemeDark',
    text: 'Header.ThemeDarkKey',
    value: THEME_MODE.dark,
  },
  {
    Preview: SystemPreview,
    qaName: 'userThemeMatchBrowser',
    text: 'Header.ThemeMatchBrowserKey',
    value: THEME_MODE.system,
  },
]
